import { render } from "./Home.vue?vue&type=template&id=7ddcf984&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=7ddcf984&scoped=true&lang=css"

import exportComponent from "E:\\yl\\web\\lvxingshibie-backend\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddcf984"]])

export default __exports__